import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { NavigationService } from '../navigation.service';

export const redirectGuardService = (route: ActivatedRouteSnapshot): Observable<boolean> => {
    const navigationService = inject(NavigationService);
    navigationService.locationHref(route.data.externalUrl);

    return of(false);
};
